
import singleTextMixin from './SingleTextMixin.vue'

export default {
  name: 'subheading'

  mixins: [singleTextMixin]

  data: -> {
    blockCss: 'subheading'
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/SubheadingBlock.vue